import { ReplaceButtonProps } from './Types'
import { track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { ToolbarButton } from '../../components/ToolbarButton'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { useReplaceImage } from 'components/Design/ShapesTab/components/useReplaceImage'

const ReplaceButton = track(
  observer(({ editor, selectedShape }: ReplaceButtonProps) => {
    const { replace } = useReplaceImage({ editor, selectedShape })

    return (
      <ToolbarButton frontIcon={ArrowRefresh2} onPress={replace}>
        Replace
      </ToolbarButton>
    )
  }),
)

export { ReplaceButton }
